/* eslint-disable max-len */
import React from 'react'
// import Image from 'next/image'
import PropTypes from 'prop-types'

const MilestoneBenefitsComponent = ({
    text, title, number, milestoneBenefitsComponentStyles,
}) => (
    <div className="milestonebenefits-component" style={milestoneBenefitsComponentStyles}>
        <div className="milestonebenefits-number">
            <h2>{number}</h2>
        </div>
        <div className="milestonebenefits-component-text">
            <p className="milestonebenefits-component-title">{title}</p>
            <p>{text}</p>
        </div>
    </div>
)

MilestoneBenefitsComponent.propTypes = {
    text: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    milestoneBenefitsComponentStyles: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default MilestoneBenefitsComponent
